import { Container } from "react-bootstrap";
import styles from "../../../assets/styles/ProjectPage.module.css"
import RecommendationsPageView from "./RecommendationsPageView";
import { useParams } from "react-router-dom";
import NotFoundPage from "../../NotFound/NotFoundPage";
import {Administrator} from "../../../services/models/administrator";
import {SubUser} from "../../../services/models/sub_user";
import React from "react";
interface Props {
    user:Administrator | SubUser | null
}
const RecommendationsPage: React.FC<Props> = ({user}) => {
    const {sectorId} = useParams();
    return (
        <Container className={styles.projectPage}>
            <>
                {sectorId ?
                    <RecommendationsPageView sectorId={sectorId} user={user}/> :
                    <NotFoundPage/>
                }
            </>
        </Container>
    );
};

export default RecommendationsPage;